import { render, staticRenderFns } from "./HasRoomDamagesQuestion.vue?vue&type=template&id=b0a91bca&scoped=true"
import script from "./HasRoomDamagesQuestion.vue?vue&type=script&lang=ts"
export * from "./HasRoomDamagesQuestion.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b0a91bca",
  null
  
)

export default component.exports